import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import radioImg from '../../assets/img/radio.svg';
import radioImgFail from '../../assets/img/radio-fail.svg';
import radioCheckedImg from '../../assets/img/radio-checked.svg';
import radioCheckedImgFail from '../../assets/img/radio-checked-fail.svg';

const propTypes = {
  currentLang: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  langs: PropTypes.array.isRequired,
  invalidLanguages: PropTypes.array.isRequired,
};

class BaseModuleLangSelect extends Component {
  constructor(props) {
    super(props);
    this.getLangItems = this.getLangItems.bind(this);
  }

  getLangItems() {
    const { langs } = this.props;

    if (langs.length <= 1) {
      return null;
    }

    return langs.map((lang) => {
      const { currentLang, onSelect, invalidLanguages } = this.props;
      const failed = invalidLanguages.includes(lang.code);
      return (
        <div
          key={lang.code}
          className="c-bb-basemodule-header-radio__element"
          style={{ color: failed ? 'red' : undefined }}
          onClick={() => onSelect(lang.code)}
        >
          {currentLang === lang.code
            ? <img src={failed ? radioCheckedImgFail : radioCheckedImg} alt="radio" />
            : <img src={failed ? radioImgFail : radioImg} alt="radio" />
          }
          &nbsp;
          {lang.code.toUpperCase()}
        </div>
      );
    });
  }

  render() {
    return (
      <div className="c-bb-basemodule-header-radio">
        {this.getLangItems()}
      </div>
    );
  }
}

BaseModuleLangSelect.propTypes = propTypes;

const mapStateToProps = state => ({
  invalidLanguages: get(state, 'form.baseModuleForm.syncErrors.languages', []),
});

export default connect(mapStateToProps)(BaseModuleLangSelect);



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleLangSelect.js